import { Spinner } from '@getethos/ethos-design-system-v2';
import classNames from 'classnames';
import React from 'react';
import { Resource } from '../constants/resource';
import styles from './Loading.module.scss';

export const Loading = ({ fullscreen }: { fullscreen: boolean }) => (
  <div
    className={fullscreen ? styles.fullscreen : ''}
    aria-busy="true"
    aria-live="polite"
    aria-valuetext={Resource.LOADING}
    role="progressbar"
  >
    <Spinner size="xl" />
    <span className={classNames('body-l-reg', styles.text)}>
      {Resource.LOADING}
    </span>
  </div>
);
